import { createTheme } from "@material-ui/core";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#00d084",
      light: "#6b6b6b"
    },
    secondary: {
      main: "#00d084",
    },
  },
  overrides: {
    MuiGrid: {
      "spacing-xs-2": {
        width: "calc(99% + 16px)",
      },
    },
  },
});


